import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  registerUser,
  loginUser,
  verifyEmail,
  updateProfile,
  getProfile,
  forgotPassword,
  resetPassword,
  updateBusinessPages,
  getAllRestaurants,
  GoogleSearch,
  GoogleSearchNearByAddress,
  addBusiness,
  getMyBusiness,
  getSingleBusiness,
  editBusiness,
  editRequest,
  resendVerifyEmail,
  googleToken,
  addFacebookReviews,
  addYelpReviews,
  addTwitterReviews,
  addUpdatedTwitterReviews,
  addUpdatedYelpReviews,
  addUpdatedfacebookReviews,
  addUpdatedGoogleReviews,
  scrapeUrl,
  scrapeAll,
  updateAll,
  removeBusiness,
  deleteUser,
  updateSrapping,
  facebookToken,
  getFbData,
  getBusinessIntelligence,
  getLocalIntelligence,
  getBusinessSummary,
  getBusinessInsights,
  getRequestReview,
  createReview,
  sendRequest,
  deleteRequest,
  cancelRequest,
  RequestByLink,
  markReview,
  getRequestReviewCount,
  getGenericReviewRequest,
  GenericRequestByLink,
  genericRequest,
  updateReviewRequest,
  verifyEmailLanding,
  googleLoginUser,
  updateBusinessAddress,
  googleOwnerShip,
  facebookOwnerShip,
  compareMe,
  RAmoments,
  RequestADemo,
  registerCrmUser,
  getMoment,
  getOffers,
  sendEmail,
  sendMomentEmail,
  getRequestReviewList,
  getReviewRequestByID,
  editReviewRequestByID,
  deleteReviewRequestByID,
  sendReviewRequest,
  markReviewRequestDone,
  updateMomentStatus,
  getReviewRequestByIdCrm,
  createBusiness,
  fetchBusiness,
  assignBusinesstocrm,
  fetchUser
} from "../../services/auth";

// register
export const registerUserAsync = createAsyncThunk("auth/register", async (userData) => {
  try {
    const response = await registerUser(userData);
    return response;
  } catch (error) {
    throw error;
  }
});

export const registerCrmUserAsync = createAsyncThunk("User", async (userData) => {
  try {
    const response = await registerCrmUser(userData);
    return response;
  } catch (error) {
    throw error;
  }
});
// login
export const loginUserAsync = createAsyncThunk("auth/login", async (userData) => {
  try {
    const response = await loginUser(userData);

    return response;
  } catch (error) {
    return error.response.data;
  }
});


// google login
export const googleLoginUserAsync = createAsyncThunk("auth/google-login", async (userData) => {
  try {
    const response = await googleLoginUser(userData);

    return response;
  } catch (error) {
    return error.response.data;
  }
});

//verify email
export const verifyEmailAsync = createAsyncThunk("auth/verifyEmail", async (userData) => {
  try {
    const response = await verifyEmail(userData);
    return response;
  } catch (error) {
    throw error;
  }
});

export const verifyEmailLandingAsync = createAsyncThunk("auth/verifyEmailLanding", async (userData) => {
  try {
    const response = await verifyEmailLanding(userData);
    return response;
  } catch (error) {
    throw error;
  }
});

export const resendVerifyEmailAsync = createAsyncThunk("auth/ResendVerifyEmail", async (payload) => {
  try {
    const response = await resendVerifyEmail(payload);
    return response;
  } catch (error) {
    throw error;
  }
});

//update Profile
export const updateProfileAsync = createAsyncThunk(
  'auth/update-profile',
  async (userData) => {
    try {
      const response = await updateProfile(userData);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

//fetch Profile
  export const getProfileAysnc = createAsyncThunk(
    'auth/get-profile',
    async (userData) => {
      try {
        const response = await getProfile(userData);
        if (response?.data?.userProfile?.username===null ) {
          var email = response?.data?.userProfile?.email ;
          var userName = "";
          var password = "";
          switch (true) {
            case !!email: {
              const namePart = email.split("@")[0]; 
              const randomNum = Math.floor(10000 + Math.random() * 90000); 
              userName = `${namePart}${randomNum}`;
              password = userName;
              break;
            }
            default: {
              // fallback if no email
              userName = "guest" + Math.floor(10000 + Math.random() * 90000);
              password = userName;
              break;
            }
          }
          const updateData = {
            email: email,
            first_name: "Tavlo",
            last_name: "Owner",
            emailAddress: email, 
            username: userName, 
            password: password,
            passwordConfirm: password,
            rolesIds: ["68a742885cfd0e050"],
            rolesNames: { "68a742885cfd0e050": "owner" },
          };
           const formData = new FormData();
          Object.entries(updateData).forEach(([key, value]) => {
            if (typeof value === "object") {
              formData.append(key, JSON.stringify(value));
            } else {
              formData.append(key, value);
            }
          });
          const crmData = {
            email: email,
            first_name: "Tavlo",
            last_name: "Owner",
            emailAddress: email, 
            userName: userName, 
            password: password,
            passwordConfirm: password,
            rolesIds: ["68a742885cfd0e050"],
            rolesNames: { "68a742885cfd0e050": "owner" },
          };
          const fallbackResponse = await updateProfile(formData)
          
          .then(() => registerCrmUser(crmData))
          .then(() => getProfile(userData))
          .catch((error) => {
            console.error("Error updating profile:", error)});
          return fallbackResponse?.data;
        }
         try {
        const username = response?.data?.userProfile?.username;
        const userResponse = await fetchUser(username);
         const payload = {
        created_by_id: "68a9ac765a4897383",
        assigned_user_id: userResponse?.data.list[0].id,
      };
      await assignBusinesstocrm(payload, username);
      } catch (error) {
        console.error("⚠️ Error calling fetchUser:", error);
      }

        if (response?.data?.businesses) {
          return response?.data;
        }
        return response?.data;
      } catch (error) {
        throw error;
      }
    }
  );

export const deleteAccountAsync = createAsyncThunk(
  'auth/delete-profile',
  async (userData) => {
    try {
      const response = await deleteUser(userData);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const forgotPasswordAysnc = createAsyncThunk(
  'auth/forgot-password',
  async (userData) => {
    try {
      const response = await forgotPassword(userData);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const resetPasswordAysnc = createAsyncThunk(
  'auth/reset-password',
  async ({ payload, config }) => {
    try {
      const response = await resetPassword({ payload, config });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);


export const updateBusinessPagesAysnc = createAsyncThunk(
  'auth/update-business-pages',
  async (payload) => {
    try {
      const response = await updateBusinessPages(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getAllRestaurantsAysnc = createAsyncThunk(
  'auth/get-all-restaurant-name',
  async (payload) => {
    try {
      const response = await getAllRestaurants(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const GoogleSearchAysnc = createAsyncThunk(
  'auth/Google-search',
  async (payload) => {
    try {
      const response = await GoogleSearch(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const GoogleSearchNearByAddressAysnc = createAsyncThunk(
  'auth/Google-search-nearby-address',
  async (payload) => {
    try {
      const response = await GoogleSearchNearByAddress(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getGoogleReviewAysnc = createAsyncThunk(
  'auth/add-google-Business',
  async (payload) => {
    try {
      const response = await addBusiness(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getFacebookReviewAysnc = createAsyncThunk(
  'auth/add-facebook-Business',
  async (payload) => {
    try {
      const response = await addFacebookReviews(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);


export const getYelpReviewAysnc = createAsyncThunk(
  'auth/add-yelp-Business',
  async (payload) => {
    try {
      const response = await addYelpReviews(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getTwitterReviewAysnc = createAsyncThunk(
  'auth/add-twitter-Business',
  async (payload) => {
    try {
      const response = await addTwitterReviews(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getUpdatedGoogleReviewAysnc = createAsyncThunk(
  'auth/add-updated-Google-Business',
  async (payload) => {
    try {
      const response = await addUpdatedGoogleReviews(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getUpdatedFacebookReviewAysnc = createAsyncThunk(
  'auth/add-updated-facebook-Business',
  async (payload) => {
    try {
      const response = await addUpdatedfacebookReviews(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getUpdatedYelpReviewAysnc = createAsyncThunk(
  'auth/add-updated-yelp-Business',
  async (payload) => {
    try {
      const response = await addUpdatedYelpReviews(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);


export const getUpdatedTwitterReviewAysnc = createAsyncThunk(
  'auth/add-updated-twitter-Business',
  async (payload) => {
    try {
      const response = await addUpdatedTwitterReviews(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);



export const scrapeUrlAsync = createAsyncThunk(
  'auth/scrape-url',
  async (payload) => {
    try {
      const response = await scrapeUrl(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);


export const scrapeAllAsync = createAsyncThunk(
  'auth/scrape-all',
  async (payload) => {
    try {
      const response = await scrapeAll(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const updateSrappingAsync = createAsyncThunk(
  'auth/update-srapping',
  async (payload) => {
    try {
      const response = await updateSrapping(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const updateAllAsync = createAsyncThunk(
  'auth/update-all',
  async (payload) => {
    try {
      const response = await updateAll(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
export const getRequestReviewCountAysnc = createAsyncThunk(
  'auth/review-request-stats',
  async (payload) => {
    try {
      const response = await getRequestReviewCount(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const  getGenericReviewRequestAysnc = createAsyncThunk(
  'auth/get-generic-review-request',
  async (payload) => {
    try {
      const response = await getGenericReviewRequest(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
export const getMyBusinessAysnc = createAsyncThunk(
  'auth/get-my-Business',
  async (payload) => {
    try {
      const response = await getMyBusiness(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getRequestReviewAysnc = createAsyncThunk(
  'auth/get-review-requests',
  async (payload) => {
    try {
      const response = await getRequestReview(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getSingleBusinessAysnc = createAsyncThunk(
  'auth/get-single-Business',
  async (params) => {
    try {
      const response = await getSingleBusiness(params);
      return response?.data?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const editBusinessAysnc = createAsyncThunk(
  'auth/view-Business',
  async (payload) => {
    try {
      const response = await editBusiness(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const editRequestAysnc = createAsyncThunk(
  'get-review-request-by-id',
  async (payload) => {
    try {
      const response = await editRequest(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const updateReviewRequestAsync = createAsyncThunk(
  'update-review-request',
  async (payload) => {
    try {
      const response = await updateReviewRequest(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const googleTokenAsync = createAsyncThunk(
  'auth/google-token',
  async (payload) => {
    try {
      const response = await googleToken(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);


export const removeBusinessAsync = createAsyncThunk(
  'auth/remove-business',
  async (payload) => {
    try {
      const response = await removeBusiness(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);


export const facebookTokenAsync = createAsyncThunk(
  'auth/send-fbToken',
  async (payload) => {
    try {
      const response = await facebookToken(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getFbDataAsync = createAsyncThunk(
  'auth/scrape-fb-data',
  async (payload) => {
    try {
      const response = await getFbData(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getBusinessIntelligenceAsync = createAsyncThunk(
  'business/get-intelligence',
  async (business_id) => {
    try {
      const response = await getBusinessIntelligence(business_id);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
export const getLocalIntelligenceAsync = createAsyncThunk(
  'business/get-local-intelligence',
  async (business_id) => {
    try {
      const response = await getLocalIntelligence(business_id);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getBusinessSummaryAsync = createAsyncThunk(
  'business/get-summary',
  async (business_id) => {
    try {
      const response = await getBusinessSummary(business_id);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getBusinessInsightsAsync = createAsyncThunk(
  'business/get-insights',
  async (business_id) => {
    try {
      const response = await getBusinessInsights(business_id);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);


export const createReviewRequest = createAsyncThunk(
  'business/add-review-request',
  async (payload) => {
    try {
      const response = await createReview(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const sendRequestReview = createAsyncThunk(
  'business/send-review-request',
  async (payload) => {
    try {
      const response = await sendRequest(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
export const deleteRequestReview = createAsyncThunk(
  'business/delete-review-request',
  async (payload) => {
    try {
      const response = await deleteRequest(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const cancelRequestReview = createAsyncThunk(
  'business/reset-review-request',
  async (payload) => {
    try {
      const response = await cancelRequest(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const reviewRequestByLink = createAsyncThunk(
  'get-review-request-by-link',
  async (payload) => {
    try {
      const response = await RequestByLink(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
export const genericReviewRequestByLink = createAsyncThunk(
  'get-generic-review-request-by-link',
  async (payload) => {
    try {
      const response = await GenericRequestByLink(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
export const genericRequestScan = createAsyncThunk(
  'generic-request-scan',
  async (payload) => {
    try {
      const response = await genericRequest(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
export const markReviewDonRequest = createAsyncThunk(
  'mark-review-request-done',
  async (payload) => {
    try {
      const response = await markReview(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const checkGoogleBusinessOwnership = createAsyncThunk(
  'check_google_business_ownership',
  async (payload) => {
    try {
      const response = await googleOwnerShip(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const checkFacebookBusinessOwnership = createAsyncThunk(
  'check_facebook_business_ownership',
  async (payload) => {
    try {
      const response = await facebookOwnerShip(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const updateBusinessAddressAsync = createAsyncThunk(
  'auth/update-business-address',
  async (payload) => {
    try {
      const response = await updateBusinessAddress(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const chatbotCompareMeAsync = createAsyncThunk(
  'chatbot/compare-me',
  async (payload) => {
    try {
      const response = await compareMe(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const chatbotRAmomentssSggestionAsync= createAsyncThunk(
  'chatbot/tavlo-moments-suggestion',
  async (payload) => {
    try {
      const response = await RAmoments(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

// RequestADemo
export const requestADemoAsync= createAsyncThunk(
  'request-a-demo',
  async (payload) => {
    try {
      const response = await RequestADemo(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getMomentAsync = createAsyncThunk(
  'momemts',
  async ({ username, maxSize = 5, offset = 3 }) => {
    try {
      const response = await getMoment(username, { maxSize, offset });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getOfferAsync = createAsyncThunk(
  'offers',
  async ({ username  }) => {
    try {
      const response = await getOffers(username);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const sendEmailAsync = createAsyncThunk(
  'offers',
  async ({ payload  }) => {
    try {
      const response = await sendEmail(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const sendMomentEmailAsync = createAsyncThunk(
  'offers',
  async ({ payload  }) => {
    try {
      const response = await sendMomentEmail(payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getRequestReviewListAsync = createAsyncThunk(
  'CRequestReviewList',
  async ({ username, maxSize = 5, offset = 3 }) => {
    try {
      const response = await getRequestReviewList(username, { maxSize, offset });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getReviewRequestByIdAsync = createAsyncThunk(
  'review-request/id',
  async ({ username, contact_id }) => {
    try {
      const response = await getReviewRequestByID(username, contact_id);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const editReviewRequestByIdAsync = createAsyncThunk(
  'CRequestReviewList/edit',
  async ({ username, request_id, formDataObject }) => {
    try {
      const response = await editReviewRequestByID(username, request_id, formDataObject);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

// CRequestReviewList
export const deleteReviewRequestByIdAsync = createAsyncThunk(
  'CRequestReviewList/id',
  async ({ username, deletedId }) => {
    try {
      const response = await deleteReviewRequestByID(username, deletedId);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const sendReviewRequestAsync = createAsyncThunk(
  'send-Review-Request',
  async ({ payload }) => {
    try {
      const response = await sendReviewRequest( payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const markReviewRequestDoneAsync = createAsyncThunk(
  'mark-review-request-done',
  async ({ payload }) => {
    try {
      const response = await markReviewRequestDone( payload);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

// updateMomentStatus
export const updateMomentStatusAsync = createAsyncThunk(
  'mark-review-request-done',
  async ({ payload, id, username }) => {
    try {
      const response = await updateMomentStatus( payload, id,username);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const getReviewRequestByIdCrmAsync = createAsyncThunk(
  'get-review-request-by-id-crm',
  async (formData) => { // Accept formData directly
    try {
      const response = await getReviewRequestByIdCrm(formData);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const fetchUserAsync = createAsyncThunk(
  'User',
  async (username) => {
    try {
      const response = await fetchUser(username);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);